export default "__VITE_ASSET__B1I24FY6__"